import { render, staticRenderFns } from "./SalesFlyerSideMenu.vue?vue&type=template&id=4db8c518"
import script from "./SalesFlyerSideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesFlyerSideMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SalesFlyerSideMenu.vue?vue&type=style&index=0&id=4db8c518&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports